
import { Vue, Component } from 'vue-property-decorator'
import store from '@/store'
import UpdatePassword from './update-password.vue'
@Component({
  name: 'Header',
  components: { UpdatePassword }
})
export default class Header extends Vue {
  input: string = ''
  circleUrl = ''
  feedbackCount = 0
  updatePasswordVisible = false
  haveFeedbackAuth = false
  refold = ''

  // 创建时触发
  created() {
    this.refold = this.$store.getters.isUnfold
    this.getHeadImage()
    this.haveFeedbackAuth = this.isAuth('feedback:page')
    if (this.haveFeedbackAuth) {
      this.getFeedbackCount()
    }
  }
  // 挂载成功出发
  mounted() {}
  getHeadImage() {
    this.$request({
      url: '/bjba/yhgl/getHeadImageByUserName',
      method: 'get',
      params: {
        username: this.$store.getters.user.username
      }
    })
      .then(response => {
        console.log(response)
        let data = response.data
        if (data) {
          this.circleUrl = 'data:image/png;base64,' + data.data
        }
      })
      .catch(error => {
        console.log(error)
      })
  }
  goFeedBack() {
    this.$router.push({
      path: '/bjba/feedback/list'
    })
  }
  getFeedbackCount() {
    this.$request({
      url: '/bjba/feedbackReadLog/unReadCount',
      method: 'get'
    })
      .then(response => {
        this.feedbackCount = response.data.data
      })
      .catch(error => {
        console.log(error)
      })
  }
  handleCommand(command) {
    if (command === 'logout') {
      this.$confirm('确定要退出当前登录吗?', '提示', {
        confirmButtonText: '退出',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          sessionStorage.removeItem('triman_bsrkapp_store')
          this.$store.commit('logout')
          this.$router.options.isAddDynamicMenuRoutes = false
          this.$router.replace('/login')
          //TODO 清除路由
          location.reload()
        })
        .catch(() => {})
    } else if (command === 'personal') {
      this.$router.push('/bjba/grzx')
    } else if (command === 'updatePassword') {
      this.updatePasswordVisible = true

      this.$nextTick(() => {
        this.$refs.updatePassword.init()
      })
    }
  }
  toPath1(){
    this.$router.push({path:'/bjba/home'});
  }

  //菜单展开折叠
  funRefold() {
    let refold = this.$store.getters.isUnfold
    this.$store.commit('updateUnfold', !refold)
  }
  get isCollapse() {
    return this.$store.getters.isUnfold
  }
  get username() {
    return this.$store.getters.user.name
  }
}
